export const home = {
  heroTitle: "Find The Best AllChinaBuy Spreadsheet In One Place",
  heroSubtitle: "Discover trusted spreadsheet links, verified sellers, buying guides, and the latest product finds updated weekly.",
  heroDropdownLabel: "Browse by Category",
  trustBadge1: "10,000+ Product Links",
  trustBadge2: "Weekly Updates",
  trustBadge3: "Trusted Sellers",
  trustBadge4: "Buying Safety Guides",
  trustBadge5: "Free Spreadsheet Access",
  introTitle: "The Ultimate AllChinaBuy Spreadsheet Directory",
  introText1: "Looking for the best AllChinaBuy Spreadsheet? Our platform helps buyers discover trusted sellers, popular products, safe purchasing methods, and updated spreadsheet links.",
  introText2: "Whether you are a beginner or experienced buyer, our guides make finding quality products easier and safer.",
  benefitsTitle: "Why Use AllChinaBuy Spreadsheet?",
  benefit1: "Save Time",
  benefit2: "Compare Products Quickly",
  benefit3: "Discover Trusted Sellers",
  benefit4: "Avoid Scam Listings",
  benefit5: "Access Weekly Updates",
  shopByCategory: "Shop by Category",
  browseAll: "Browse All",
  categoriesSub: "Categories",
  featuredTitle: "Top Product Finds",
  featuredSubtitle: "Discover the most popular categories with thousands of verified product links",
  trustTitle: "Why Buyers Trust Us",
  trustContent: "We manually verify every spreadsheet entry to ensure you get only legitimate product links. Our team cross-references seller ratings, reviews, and transaction history before adding any entry. Thousands of buyers rely on our directory to find quality products without the guesswork.",
  trustSignature: "AllChinaBuy Team",
  trustSince: "Verified Since 2024",
  trustCTA: "Learn About Our Process",
  editorialTag: "Our Editorial Policy",
  editorialTitle: "Manually Reviewed / Weekly Updated / Buyer First",
  editorialDesc: "Every link in our spreadsheet directory is independently researched and verified. We never accept payments for listings, and our recommendations are based solely on product quality, seller reliability, and buyer satisfaction. Updates are published every week to keep you informed about the latest finds.",
  articleEntryTitle: "Want to master the AllChinaBuy Spreadsheet?",
  articleEntryHighlight: "AllChinaBuy Spreadsheet",
  articleEntryDesc: "Read our complete buying guide",
  articleEntryCTA: "Read Buying Guide →",
  safetyTitle: "Safety Center",
  safety1: "Always verify products before purchasing.",
  safety2: "Review QC images carefully.",
  safety3: "Compare multiple sellers.",
  safety4: "Understand shipping risks.",
  faqTitle: "Frequently Asked Questions",
  faq1Q: "What is an AllChinaBuy Spreadsheet?",
  faq1A: "An AllChinaBuy Spreadsheet is a curated collection of product links organized by category, helping buyers quickly find trusted sellers and popular items on the AllChinaBuy platform. It saves hours of manual searching and helps you discover quality products with verified seller ratings.",
  faq2Q: "How often is the spreadsheet updated?",
  faq2A: "Our AllChinaBuy Spreadsheet is updated weekly with new product links, removed dead links, and refreshed seller ratings. We continuously monitor the platform to ensure you always have access to the most current and reliable product information.",
  faq3Q: "Is the AllChinaBuy Spreadsheet free to use?",
  faq3A: "Yes, our AllChinaBuy Spreadsheet directory is completely free to access. Simply browse through the categories, find products you love, and use our trusted links to visit the main shopping platform directly.",
  faq4Q: "How do I use the AllChinaBuy Spreadsheet safely?",
  faq4A: "Always cross-reference seller ratings, review QC images before purchasing, compare prices across multiple listings, and understand the shipping policies. Our safety guides provide detailed steps for secure buying on the platform.",
};